@if (open || serviceOpen) {
  <div
    class="container"
    [class]="{
      hidden: !(open && serviceOpen),
      'variant-error': snackbarService.snackbarData().variant === 'error-snack',
      'variant-info': snackbarService.snackbarData().variant === 'info-snack',
      'variant-success': snackbarService.snackbarData().variant === 'success-snack',
      'variant-warning': snackbarService.snackbarData().variant === 'warning-snack',
    }"
  >
    <i [class]="'icon isax-outlined isax-outlined-' + getIconFromType"></i>
    <span class="typography-label-medium">
      {{ snackbarService.snackbarData().message }}
    </span>
  </div>
}
